import React from 'react';
import Icon from '../../../components/AppIcon';

const ServiceOrderStats = ({ orders }) => {
  const stats = {
    total: orders?.length,
    pending: orders?.filter(order => order?.status === 'Pendente')?.length,
    inProgress: orders?.filter(order => order?.status === 'Em Andamento')?.length,
    completed: orders?.filter(order => order?.status === 'Concluído')?.length,
    highPriority: orders?.filter(order => order?.priority === 'Alta')?.length
  };

  const statCards = [
    {
      title: 'Total de OS',
      value: stats?.total,
      icon: 'ClipboardList',
      color: 'text-primary',
      bgColor: 'bg-primary/10'
    },
    {
      title: 'Pendentes',
      value: stats?.pending,
      icon: 'Clock',
      color: 'text-warning',
      bgColor: 'bg-warning/10'
    },
    {
      title: 'Em Andamento',
      value: stats?.inProgress,
      icon: 'Play',
      color: 'text-primary',
      bgColor: 'bg-primary/10'
    },
    {
      title: 'Concluídas',
      value: stats?.completed,
      icon: 'CheckCircle',
      color: 'text-success',
      bgColor: 'bg-success/10'
    },
    {
      title: 'Alta Prioridade',
      value: stats?.highPriority,
      icon: 'AlertTriangle',
      color: 'text-error',
      bgColor: 'bg-error/10'
    }
  ];

  return (
    <div className="grid grid-cols-2 lg:grid-cols-5 gap-4 mb-6">
      {statCards?.map((stat, index) => (
        <div
          key={index}
          className="bg-card border border-border rounded-lg p-4 shadow-professional hover:shadow-modal transition-all duration-200"
        >
          <div className="flex items-center space-x-3">
            <div className={`w-10 h-10 ${stat?.bgColor} rounded-lg flex items-center justify-center flex-shrink-0`}>
              <Icon name={stat?.icon} size={20} className={stat?.color} />
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-2xl font-bold text-card-foreground">
                {stat?.value}
              </p>
              <p className="text-sm text-muted-foreground truncate">
                {stat?.title}
              </p>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ServiceOrderStats;